<div class="d-lg-flex gap-2 d-block">
  <div
    class="d-flex gap-1 flex-wrap justify-content-center justify-content-lg-start mb-2 mb-lg-0"
  >
    <div>
      <div
        class="position-relative bg-white border text-dark text-center rounded d-flex align-items-center p-3 form-control justify-content-center fw-semibold"
        role="button"
      >
        <span
          >{{ selectedDate | customDate: "d MMM y" }} - {{ selectedWeekEnd |
          customDate: "d MMM y" }}</span
        >
        <span><i class="fa-solid fa-calendar ms-1"></i></span>

        <input
          class="hidden-calendar-lookup"
          type="date"
          [(ngModel)]="selectedDate"
          [max]="nextMonday"
          (change)="onSelectedDateChange()"
        />
      </div>
      <!-- <div class="form-floating">
        <input
          class="form-control"
          type="date"
          placeholder="Pick Date"
          [(ngModel)]="selectedDate"
          (change)="onSelectedDateChange()"
        />
        <label>Pick Date</label>
      </div> -->
    </div>

    <div
      (click)="changeWeek('-')"
      class="border rounded p-2 d-flex align-items-center text-secondary"
      role="button"
    >
      <i class="fa-solid fa-caret-left fs-3"></i>
    </div>
    @if(currentMonday != selectedDate){
    <div
      (click)="changeWeek('+')"
      class="border rounded p-2 d-flex align-items-center text-secondary"
      role="button"
    >
      <i class="fa-solid fa-caret-right fs-3"></i>
    </div>
    }
  </div>
  @if (currentMonday != selectedDate && largeView) {
  <div
    class="d-flex gap-1 flex-wrap justify-content-center justify-content-lg-start"
  >
    <div
      class="border rounded py-lg-2 px-lg-5 d-flex align-items-center text-secondary gap-2 px-5 py-2 small text-uppercase fw-semibold justify-content-center"
      (click)="changeWeek('today')"
      role="button"
    >
      Current Week
    </div>
  </div>
  } @if ( clockInOutTimeSheetData?.length || selectedUser?.id ||
  shiftSearchString || selectedJobType?.id ) {
  <div class="row row-cols-1 row-cols-lg-3">
    <div class="col">
      <dt class="d-none">Job Type</dt>
      <select
        class="form-select form-select-lg py-lg-3"
        role="button"
        [ngModel]="selectedJobType?.id || ''"
        (change)="onSelectJobType($event)"
      >
        <option [value]="''">Show All Jobs</option>
        @for (jType of availableJobTypes; track $index) {
        <option [value]="jType.id">{{ jType?.name }}</option>
        }
      </select>
    </div>
    <div class="col">
      @if (selectedUser?.id) {
      <dl class="px-2">
        <dt>User</dt>
        <dd class="d-flex gap-2 align-items-center">
          <div>{{ selectedUser?.full_name }}</div>
          <div
            class="edit-button"
            (click)="onSelectUser({}); editField('user')"
          ></div>
        </dd>
      </dl>
      } @else {
      <gtapp-auto-complete
        z
        [data]="userLookupDataList"
        placeHolder="User Name"
        searchKeyword="full_name"
        [initialValue]="selectedUser?.full_name"
        [itemTemplate]="assigneeListTemplate"
        (inputChanged)="searchUsers($event)"
        (selected)="onSelectUser($event)"
        [enableCloseOption]="true"
        inputId="userLookupFieldId"
        (fieldCleared)="editField('user')"
        (inputFocused)="inputFocused('user')"
      >
      </gtapp-auto-complete>
      <ng-template #assigneeListTemplate let-item>
        <div class="d-flex gap-2 flex-wrap">
          <span> {{ item?.full_name }} </span>
          @if (item?.access_status === 2) {
          <div
            class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
          >
            Casual
          </div>
          }
        </div>

        @if (item?.subcontractors?.length) {
        <div class="small text-secondary">
          🟧Subcontractor:
          <span class="subcontractor-name">{{ item?.subcontractors }}</span>
        </div>
        }
      </ng-template>
      }
    </div>
    <div class="col">
      @if (shiftSearchString) {
      <dl class="px-2">
        <dt>Client/Site/Patrol</dt>
        <dd class="d-flex gap-2 align-items-center">
          <div>{{ shiftSearchString }}</div>
          <div
            class="edit-button"
            (click)="onSelectShift({}); editField('shift')"
          ></div>
        </dd>
      </dl>
      } @else {
      <gtapp-auto-complete
        [data]="shiftLookupDataList"
        placeHolder="Client/Site/Patrol"
        searchKeyword="shift_name"
        [initialValue]="shiftSearchString"
        [itemTemplate]="shiftLookupTemplate"
        (inputChanged)="onShiftSearch($event)"
        (selected)="onSelectShift($event)"
        [enableCloseOption]="true"
        inputId="shiftLookupFieldId"
        (fieldCleared)="editField('shift')"
        (inputFocused)="inputFocused('shift')"
        [additionalConfig]="{
              containerHeightMax: largeView
                ? 'calc(100vh - 15rem)'
                : 'calc(100vh - 25rem)',
            }"
      >
      </gtapp-auto-complete>
      <ng-template #shiftLookupTemplate let-item>
        <div class="d-flex gap-2 flex-wrap flex-column">
          <span> {{ item?.shift_name }} </span>
          <span class="text-secondary">
            [{{ item?.job_type_name || (item?.runsheet_id ? "Scheduled Patrol" :
            "Checkpoint Patrol") }}]
          </span>
        </div>
      </ng-template>
      }
    </div>
  </div>
  }
</div>

@if (largeView) {
<gtapp-gt-custom-table
  [deskTopTableData]="clockInOutTimeSheetData"
  [desktopTableDetails]="clockInOutTimeSheetTableInfo"
  [otherParams]="otherParamsClockInOutTimeSheet"
  (paginationChange)="onChangePaginationTimeSheetLog($event)"
  (sortColumn)="sortColumnTimeSheetLog($event)"
  (searchColumn)="searchColumnTimeSheetLog($event)"
  (actionClick)="
      onActionClick(
        forceClockOutTemplate,
        notesTemplate,
        $event,
        eventDetailTemplate, menuOptionTemplate,modifyClockInOutTemplate
      )
    "
>
</gtapp-gt-custom-table>
} @else {
<div class="d-flex gap-2 flex-column pt-2">
  @for (item of clockInOutTimeSheetData; track $index) {
  <div
    class="card border bg-secondary-subtle p-2 text-dark"
    [class.border-danger]="item?.failed_event_id"
  >
    <div class="d-flex gap-2 justify-content-between">
      <div>
        {{ item?.job_data?.site_name || item?.runsheet_data?.name ||
        item?.patrol_route_data?.name }}
      </div>
      <div>
        @if ( ["approved", "rejected"].includes(
        item?.additional_info?.clock_report?.status ) ) { @if
        (item?.additional_info?.clock_report?.status == "approved") {
        <span class="bg bg-success text-light rounded small-font p-2 py-1">
          Approved
        </span>
        } @else {
        <span class="bg bg-danger rounded small-font p-2 py-1 text-light">
          Rejected
        </span>
        } }
      </div>
    </div>

    @if (item?.job_data?.company_name) {
    <div class="small">{{ item?.job_data?.company_name }}</div>
    }
    <div class="d-flex gap-2 justify-content-between my-2">
      <div>
        <span class="text-secondary small">Shift: </span>
        {{ item?.shift_start | customDate: "EEE d MMM y" }} {{
        item?.job_data?.start_datetime || item?.runsheet_data?.start_datetime ||
        item?.patrol_route_data?.start_datetime | customDate: "HH:mm" }} - {{
        getDateTimeWithSameDayCheck( getOnlyDateFromDateObj(item?.shift_start),
        item?.job_data?.end_datetime || item?.runsheet_data?.end_datetime ||
        item?.patrol_route_data?.end_datetime ) }}
      </div>
      <div class="small">{{ item?.user_name }}</div>
    </div>
    <div class="d-flex gap-2 mb-2">
      <div class="flex-grow-1">
        @if (item?.clocked_out_at) { {{ getDateTimeWithSameDayCheck(
        getOnlyDateFromDateObj(item?.shift_start), item?.clocked_in_at ) }} - {{
        getDateTimeWithSameDayCheck( getOnlyDateFromDateObj(item?.shift_start),
        item?.clocked_out_at ) }} } @else {
        <span class="text-danger fw-medium">
          {{ getDateTimeWithSameDayCheck(
          getOnlyDateFromDateObj(item?.shift_start), item?.clocked_in_at ) }}
        </span>

        <span
          (click)="
                  onActionClick(
                    forceClockOutTemplate,
                    notesTemplate,
                    { event: item, type: 'clock_out' },
                    eventDetailTemplate, menuOptionTemplate,modifyClockInOutTemplate
                  )
                "
          role="button"
          class="btn btn-outline-primary btn-sm rounded small ms-2"
        >
          CLOCK OUT
        </span>
        }
      </div>
      <div>[{{ this.getSessionDuration(item) }}]</div>
    </div>
    <!-- ACTION_CLOCK_IN = 0, _("CLOCKED IN")
        ACTION_CLOCK_OUT = 1, _("CLOCKED OUT")
        ACTION_CHECK_IN = 2, _("CHECKED IN")
        ACTION_SEND_SOS = 3, _("SOS SENT")
        ACTION_EARLY_CLOCK_OUT = 4, _("EARLY CLOCK OUT")
        ACTION_LATE_CLOCK_IN = 5, _("LATE CLOCK IN")
        ACTION_AUTO_CLOCK_OUT = 6, _("AUTO CLOCK OUT")
        ACTION_PROXY_CLOCK_OUT = 7, _("PROXY CLOCK OUT") -->
    @if(item?.clock_in_event_action == 5){
    <div class="text-danger small-font">LATE CLOCK IN</div>
    } @if(item?.clock_out_event_action == 4){
    <div class="text-danger small-font">EARLY CLOCK OUT</div>
    } @if(item?.clock_out_event_action == 7){
    <div class="text-danger small-font">FORCED CLOCK OUT</div>
    } @if (item?.additional_info?.clock_report?.notes) {
    <div class="d-flex gap-2 my-3 small-font text-secondary">
      <span
        >{{ item?.additional_info?.clock_report?.notes?.length > 100 ?
        item?.additional_info?.clock_report?.notes?.slice(0, 100) + "..." :
        item?.additional_info?.clock_report?.notes }}</span
      >
      <span
        role="button"
        class="edit-button m-0"
        (click)="
                onActionClick(
                  forceClockOutTemplate,
                  notesTemplate,
                  { event: item, type: 'update_note' },
                  eventDetailTemplate, menuOptionTemplate,modifyClockInOutTemplate
                )
              "
      >
      </span>
    </div>
    }
    <div
      class="d-flex gap-3 align-items-center justify-content-between bg-light-subtle rounded p-1 small-font"
    >
      @if ( ["approved", "rejected"].includes(
      item?.additional_info?.clock_report?.status ) ) {
      <span
        (click)="
                onActionClick(
                  forceClockOutTemplate,
                  notesTemplate,
                  { event: item, type: 'accept_reject' },
                  eventDetailTemplate, menuOptionTemplate,modifyClockInOutTemplate
                )
              "
        role="button"
        class="btn btn-outline-secondary btn-sm rounded small-font p-2"
      >
        RESET STATUS
      </span>
      <!-- <span>
              <i class="fa-solid fa-ellipsis-vertical md-font-size"></i>
            </span> -->
      } @else {
      <span
        (click)="
                onActionClick(
                  forceClockOutTemplate,
                  notesTemplate,
                  { event: item, type: 'approve' },
                  eventDetailTemplate, menuOptionTemplate,modifyClockInOutTemplate
                )
              "
      >
        <i class="fa-solid fa-check text-success md-font-size"></i>
      </span>
      <span
        (click)="
                onActionClick(
                  forceClockOutTemplate,
                  notesTemplate,
                  { event: item, type: 'reject' },
                  eventDetailTemplate, menuOptionTemplate,modifyClockInOutTemplate
                )
              "
      >
        <i class="fa-solid fa-xmark text-danger md-font-size"></i>
      </span>
      } @if (!item?.additional_info?.clock_report?.notes) {
      <span
        (click)="
                onActionClick(
                  forceClockOutTemplate,
                  notesTemplate,
                  { event: item, type: 'update_note' },
                  eventDetailTemplate, menuOptionTemplate,modifyClockInOutTemplate
                )
              "
        role="button"
        class="btn btn-outline-secondary btn-sm rounded small-font p-2"
      >
        ADD NOTES
      </span>
      }
      <span
        role="button"
        class="p-2"
        (click)="
              onActionClick(
                forceClockOutTemplate,
                notesTemplate,
                { event: item, type: 'show_details' },
                eventDetailTemplate, menuOptionTemplate,modifyClockInOutTemplate
              )
            "
      >
        <i class="fa-solid fa-ellipsis md-font-size"></i>
      </span>
    </div>
  </div>
  }
</div>
<div>
  <gtapp-pagination-control
    [pageSize]="rowsClockInOutTimeSheet"
    [pageNum]="pageNumClockInOutTimeSheet"
    [previous]="previousClockInOutTimeSheet"
    [totalRows]="totalRowsClockInOutTimeSheet"
    (onChangePagination)="onChangePaginationTimeSheetLog($event)"
  >
  </gtapp-pagination-control>
</div>
}

<ng-template #eventDetailTemplate let-eventDetailTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="eventDetailTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="d-flex column-gap-5 flex-wrap row-gap-2 mb-3">
      @if (selectedTimeSheetData?.user_name) {
      <dl>
        <dt>User</dt>
        <dd class="fw-semibold">
          @if (selectedTimeSheetData?.subs_user_id) {
          <span
            class="cursor-pointer"
            [gtappPopover]="userDetailPopoverTemplate"
            [popoverData]="{ userId: selectedTimeSheetData?.subs_user_id }"
          >
            {{ selectedTimeSheetData?.user_name }}
          </span>
          }
        </dd>
      </dl>
      }
      <dl>
        <dt>Duration</dt>
        <dd class="fw-bold">{{ selectedTimeSheetData?.duration }}</dd>
      </dl>
      @if (!selectedTimeSheetData?.clock_out_data?.updated_at) {
      <dl>
        <button
          class="btn btn-outline-info fw-bold btn-sm"
          (click)="
              onManualClockOut(selectedTimeSheetData, forceClockOutTemplate);
              eventDetailTemplateRef.close()
            "
        >
          Force Clock Out
        </button>
      </dl>
      } @if (selectedTimeSheetData?.job_data) {
      <dl>
        <dt>Shift</dt>
        <div
          (click)="
              eventDetailTemplateRef.close(selectedTimeSheetData?.job_data)
            "
        >
          <div role="button">
            <div class="link-view">
              {{ selectedTimeSheetData?.job_data?.site_name }} - {{
              selectedTimeSheetData?.job_data?.job_key }}
            </div>
            <div class="small text-secondary">
              {{ selectedTimeSheetData?.job_data?.site_address }}
            </div>
            <div class="fw-semibold">
              {{ selectedTimeSheetData?.job_data?.job_type_name }}
            </div>
          </div>
        </div>
      </dl>
      } @if (selectedTimeSheetData?.runsheet_data) {
      <dl>
        <dt>Scheduled Patrol</dt>
        <div
          (click)="
              eventDetailTemplateRef.close(selectedTimeSheetData?.runsheet_data)
            "
        >
          <div role="button">
            <div class="link-view">
              {{ selectedTimeSheetData?.runsheet_data?.name }}
            </div>
          </div>
        </div>
      </dl>
      } @if (selectedTimeSheetData?.patrol_route_data) {
      <dl>
        <dt>Checkpoint Patrol</dt>
        <div
          (click)="
              eventDetailTemplateRef.close(
                selectedTimeSheetData?.patrol_route_data
              )
            "
        >
          <div role="button">
            <div class="link-view">
              {{ selectedTimeSheetData?.patrol_route_data?.name }}
            </div>
          </div>
        </div>
      </dl>
      } @if ( (selectedTimeSheetData?.job_data?.start_datetime ||
      selectedTimeSheetData?.runsheet_data?.start_datetime ||
      selectedTimeSheetData?.patrol_route_data?.start_datetime) &&
      (selectedTimeSheetData?.job_data?.end_datetime ||
      selectedTimeSheetData?.runsheet_data?.end_datetime ||
      selectedTimeSheetData?.patrol_route_data?.end_datetime) ) {
      <dl>
        <dt>Schedule</dt>
        <div>
          {{ selectedTimeSheetData?.job_data?.start_datetime ||
          selectedTimeSheetData?.runsheet_data?.start_datetime ||
          selectedTimeSheetData?.patrol_route_data?.start_datetime | customDate:
          "d MMM y HH:mm" }} - {{ selectedTimeSheetData?.job_data?.end_datetime
          || selectedTimeSheetData?.runsheet_data?.end_datetime ||
          selectedTimeSheetData?.patrol_route_data?.end_datetime | customDate:
          "d MMM y HH:mm" }}
        </div>
        @if ( selectedTimeSheetData?.job_data?.shift_duration ||
        selectedTimeSheetData?.runsheet_data?.shift_duration ||
        selectedTimeSheetData?.patrol_route_data?.shift_duration ) {
        <div>
          [{{ selectedTimeSheetData?.job_data?.shift_duration ||
          selectedTimeSheetData?.runsheet_data?.shift_duration ||
          selectedTimeSheetData?.patrol_route_data?.shift_duration }}]
        </div>
        }
      </dl>
      } @if (selectedTimeSheetData?.additional_info?.clock_report?.notes) {
      <dl>
        <dt>Notes</dt>
        <dd class="gt-multi-line overflow-25vh">
          {{ selectedTimeSheetData?.additional_info?.clock_report?.notes }}
        </dd>
      </dl>
      } @if (selectedTimeSheetData?.additional_info?.clock_report?.status) {
      <dl>
        <dt>Status</dt>
        <dd
          class="fw-bold"
          [class.text-danger]="
              selectedTimeSheetData?.additional_info?.clock_report?.status ==
              'rejected'
            "
          [class.text-success]="
              selectedTimeSheetData?.additional_info?.clock_report?.status ==
              'approved'
            "
        >
          {{ selectedTimeSheetData?.additional_info?.clock_report?.status |
          uppercase }}
        </dd>
      </dl>
      }
    </div>

    <ng-template
      *ngTemplateOutlet="
        clockInOutDetailTemplate;
        context: {
          data: selectedTimeSheetData?.clock_in_data,
          action: 'clockIn',
        }
      "
    ></ng-template>
    <ng-template
      *ngTemplateOutlet="
        clockInOutDetailTemplate;
        context: {
          data: selectedTimeSheetData?.clock_out_data,
          action: 'clockOut',
        }
      "
    ></ng-template>
    @if (selectedTimeSheetData?.update_history?.length) {
    <dl>
      <dt>Updates</dt>
      <dd>
        <table class="table table-responsive table-sm table-borderless pb-4">
          <tbody>
            @for ( item of selectedTimeSheetData?.update_history; track $index )
            {
            <tr>
              <td class="small w-25">
                <div>{{ item?.updated_at | customDate: "d MMM y HH:mm" }}</div>
                <div>{{ item?.user_name }}</div>
              </td>
              <td>
                <div class="fw-semibold text-upper-case mb-2">
                  {{ item?.action }}
                </div>
                <div class="small-font d-flex gap-3 flex-wrap">
                  @if (item?.update?.previous) {
                  <dl>
                    <dt>Previous Value</dt>
                    <dd>
                      @if([5,6].includes(item?.event_action)){ {{
                      item?.update?.previous| customDate : 'd MMM y HH:mm' }}
                      }@else{ {{ item?.update?.previous }} }
                    </dd>
                  </dl>
                  } @if (item?.update?.current) {
                  <dl>
                    <dt>Update Value</dt>
                    <dd>
                      @if([5,6].includes(item?.event_action)){ {{
                      item?.update?.current | customDate : 'd MMM y HH:mm'}}
                      }@else{ {{ item?.update?.current }} }
                    </dd>
                  </dl>
                  } @if (item?.update?.reason) {
                  <dl>
                    <dt>Reason</dt>
                    <dd>{{item?.update?.reason}}</dd>
                  </dl>
                  }
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </dd>
    </dl>
    }
  </div>
</ng-template>

<ng-template #clockInOutDetailTemplate let-action="action" let-data="data">
  @if (data?.updated_at) {
  <div
    class="row mb-3"
    [ngClass]="data?.file_url ? 'row-cols-2 row-cols-xl-3' : 'row-cols-2'"
  >
    <div class="col">
      <dl>
        <dt>{{ action === "clockIn" ? "Clock In" : "Clock Out" }} Time</dt>
        <dd>{{ data?.updated_at | customDate: "d MMM y HH:mm" }}</dd>
      </dl>
      @if (data?.proxy_by || data?.event_action == 6) {
      <dl>
        <dt>Proxy</dt>
        <dd>{{ data?.proxy_by || "Auto Clock Out" }}</dd>
      </dl>
      } @if (data?.device_details?.Device) {
      <dl>
        <dt>Device</dt>
        <dd>{{ data?.device_details?.Device }}</dd>
      </dl>
      } @if (data?.device_details?.Browser) {
      <dl>
        <dt>Browser</dt>
        <dd>{{ data?.device_details?.Browser }}</dd>
      </dl>
      }
      <dl>
        @if (data?.proxy_by && data?.event_value) {
        <dt class="text-danger fw-semibold">Reason</dt>
        <dd class="gt-multi-line">{{ data?.event_value }}</dd>
        } @if ([4,5].includes(data?.event_action) && data?.event_value) {
        <dt class="text-danger fw-semibold">
          Reason for@if( action === "clockIn") { "Late Clock In" }@else{ "Early
          Clock Out" }
        </dt>
        <dd class="gt-multi-line">{{ data?.event_value }}</dd>
        }
      </dl>
    </div>
    @if (data?.file_url) {
    <div class="col">
      @if (!data?.file_loaded) {
      <div class="text-center">
        <div
          class="spinner-border text-secondary spinner-border"
          role="status"
        ></div>
      </div>
      }
      <img
        (click)="onOpenFile(data?.file_url)"
        [src]="data?.file_url"
        (load)="data.file_loaded = true"
        class="cursor-pointer rounded w-100"
        [ngClass]="
              data?.failure_reason ? 'border-danger border border-5' : ''
            "
      />
      @if (data?.file_loaded && [1, 2].includes(data?.failure_reason)) {
      <div class="text-danger text-center">
        @if(data?.failure_reason === 1){ No Face Detected }@else{ Facial ID
        Mismatch }
      </div>
      }
    </div>
    } @if (data?.gps?.lat && data?.gps?.lon) {
    <div class="col" [ngClass]="data?.file_url ? 'col-12 col-xl-4' : 'col'">
      <gtapp-map-leaflet
        [latLon]="data?.gps"
        [mapId]="'smallMapId' + action"
      ></gtapp-map-leaflet>
    </div>
    }
  </div>
  }
</ng-template>

<ng-template
  #forceClockOutTemplate
  let-forceClockOutTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Clock Out Time
      <span class="float-end" (click)="forceClockOutTemplateRef.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating mb-2">
      <input
        class="form-control"
        type="text"
        [(ngModel)]="data.reason"
        autocomplete="off"
      />
      <label>Manual Clock Out Reason (Optional)</label>
    </div>

    <div class="form-floating mb-2">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="Clock out time"
        [(ngModel)]="data.clock_out_time"
        [min]="data.minVal"
      />
      <label> Clock out time</label>
    </div>

    <div class="row row-cols-2">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="forceClockOutTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="data?.clock_out_time < data?.minVal"
          (click)="forceClockOutTemplateRef.close(data)"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #notesTemplate let-data let-notesTemplateRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Notes
      <span class="float-end" (click)="notesTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-group input-group mb-3">
      <textarea
        class="form-control"
        placeholder="Notes"
        cols="20"
        rows="5"
        wrap="hard"
        maxlength="900"
        type="text"
        [(ngModel)]="data.notes"
        id="notesInputField"
      ></textarea>
      @if (data?.notes) {
      <span
        class="input-group-text"
        (click)="data.notes = ''; clearAndFocusTextBox('notesInputField')"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
      }
    </div>
    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="notesTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="data?.oldValue == data?.notes"
          (click)="notesTemplateRef.close(data)"
        >
          Update
        </button>
      </div>
    </div>

    <!-- Request Detail Section end-->
  </div>
</ng-template>

<ng-template #menuOptionTemplate let-menuOptionTemplateRef="dialogRef" let-data>
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="menuOptionTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="row row-cols-1" id="time-attendance-menu">
      <div class="col">
        <button
          class="btn btn-secondary w-100 btn-lg"
          (click)=" menuOptionTemplateRef.close('show_details')

            "
        >
          View Details
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary w-100 btn-lg"
          (click)="menuOptionTemplateRef.close('update_note')

            "
        >
          Edit Notes
        </button>
      </div>

      @if(data?.clock_in_id){
      <div
        class="col"
        (click)="menuOptionTemplateRef.close('update_clock_in_time')"
      >
        <button class="btn btn-primary w-100 btn-lg">
          Override Clock In Time
        </button>
      </div>
      } @if(data?.clock_out_id){
      <div
        class="col"
        (click)="menuOptionTemplateRef.close('update_clock_out_time')"
      >
        <button class="btn btn-primary w-100 btn-lg">
          Override Clock Out Time
        </button>
      </div>
      }@else {
      <div class="col">
        <button
          class="btn btn-outline-info w-100 btn-lg"
          (click)="menuOptionTemplateRef.close('clock_out')"
        >
          Force Clock Out
        </button>
      </div>

      } @if ( ["approved", "rejected"].includes(
      data?.additional_info?.clock_report?.status ) ) {
      <div class="col">
        <button
          class="btn btn-outline-secondary w-100 btn-lg"
          (click)="menuOptionTemplateRef.close('accept_reject')

                "
        >
          RESET APPROVAL STATUS
        </button>
      </div>

      }
    </div>
  </div>
</ng-template>

<ng-template
  #modifyClockInOutTemplate
  let-modifyClockInOutTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Edit Clock {{data?.clock_in_id? 'In': 'Out'}} Time
      <span
        class="float-end"
        (click)="modifyClockInOutTemplateRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating mb-2">
      <input
        class="form-control"
        type="text"
        [(ngModel)]="data.reason"
        autocomplete="off"
      />
      <label> Reason </label>
    </div>

    <div class="form-floating mb-2">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="Clock out time"
        [(ngModel)]="data.newValue"
        [min]="data.minVal"
        (ngModelChange)="dateTimeCheck(data)"
      />
      <label> Clock {{data?.clock_in_id? 'In': 'Out'}} Time</label>
    </div>
    @let currentEventAction = 'clock_in_event_action' in data?
    data?.clock_in_event_action : data?.clock_out_event_action;
    @if(data?.valueChanged && ([5,0,4,1].includes(currentEventAction) )){
    <div class="row row-cols-2">
      <div class="col">
        <dt>Current Status</dt>
        <dd>
          @switch(currentEventAction){ @case (5){ Late Clock In } @case (0){
          Clock In } @case (4){ Early Clock Out } @case (1){ Clock Out } }
        </dd>
      </div>
      <div class="col">
        <dt>Updated Status</dt>
        <dd>
          @let udpatedEventAction = 'updated_clocked_in_event_action' in data?
          data?.updated_clocked_in_event_action :
          data?.updated_clocked_out_event_action; @switch(udpatedEventAction){
          @case (5){ Late Clock In } @case (0){ Clock In } @case (4){ Early
          Clock Out } @case (1){ Clock Out } }
        </dd>
      </div>
    </div>
    }

    <div class="row row-cols-2">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="modifyClockInOutTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="data?.newValue < data?.minVal || !data.reason || !data?.valueChanged"
          (click)="modifyClockInOutTemplateRef.close(data)"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
